/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));



  // ---------------------------------------------------------------------
  // Gift wrap cart upsell (snippets/gift-wrap-upsell.liquid)
  //
  // This block sits inside the cart page's own <form>, so it can't use its
  // own nested <form> (browsers silently drop a <form> nested inside
  // another <form>, which would otherwise break add-to-cart). Instead we
  // post straight to /cart/add.js and then ask the theme's cart component
  // to refresh itself, the same way the rest of the AJAX cart works.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-gift-wrap-add]');
    if (!btn) return;
    e.preventDefault();

    var wrapper = btn.closest('[data-gift-wrap-upsell]');
    if (!wrapper) return;

    var idInput = wrapper.querySelector('[data-gift-wrap-id]');
    var qtyInput = wrapper.querySelector('[data-gift-wrap-quantity]');
    var noteInput = wrapper.querySelector('[data-gift-wrap-note]');
    var errorDisplay = wrapper.querySelector('[data-error-display]');

    if (!idInput || !idInput.value) return;

    var quantity = parseInt(qtyInput && qtyInput.value, 10);
    if (!quantity || quantity < 1) quantity = 1;

    var properties = {};
    if (noteInput && noteInput.value.trim() !== '') {
      properties['Gift Note'] = noteInput.value.trim();
    }

    if (errorDisplay) {
      errorDisplay.innerHTML = '&nbsp;';
    }
    btn.classList.add('loading');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    var cartRoute = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';

    fetch(cartRoute + '/add.js', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: idInput.value,
        quantity: quantity,
        properties: properties
      })
    })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            return Promise.reject(data);
          }
          return data;
        });
      })
      .then(function() {
        // Tell the theme's cart component to refresh the line items,
        // subtotal, etc. - same event the rest of the cart uses.
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function(err) {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        var message = (err && (err.description || err.message)) || 'Could not add gift wrapping, please try again.';
        if (errorDisplay) {
          errorDisplay.innerHTML = '<div class="errors">' + message + '</div>';
        }
      });
  });

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
